<template>
    <div class="container wrap">
        <rankBox class="rank1"></rankBox>
        <!-- <rankBox class="rank2"></rankBox> -->
    </div>
</template>

<script>
import RankBox from "@/components/rankBox.vue";

export default {
    name: "rank",
    components: {RankBox}
}
</script>

<style lang="scss" scoped>
.rank1{
    background: url("~@/assets/imgs/index-bg3.png") no-repeat;
    background-size: 100% 100%;
    margin-bottom: 60px;
}
.rank2{
    background: url("~@/assets/imgs/index-bg4.png") no-repeat;
    background-size: 100% 100%;
}
.wrap{
    margin: 50px auto;
}
</style>
